import { FunctionComponent } from 'react'
import { useMount } from 'react-use'
import styled from 'styled-components'
import { OurIntlShape } from '@/i18n/typing'
import { designLayoutSize, PptxObjectType } from '@/utils/export-pptx/constants'
import { OutlineSlide } from '@/utils/export-pptx/types/slide'

interface SlideProps {
  slide: OutlineSlide
  onSlideReady?: (slide: OutlineSlide) => void
  formatMessage: OurIntlShape['formatMessage']
}

const SlideComponent: FunctionComponent<SlideProps> = ({
  slide,
  onSlideReady,
  formatMessage,
}) => {
  useMount(() => {
    onSlideReady?.(slide)
  })

  return (
    <Wrapper data-pptx-object={PptxObjectType.Shape}>
      <Title data-pptx-object={PptxObjectType.Text}>
        {formatMessage({ id: 'general:pptx_title_outline' })}
      </Title>
      <Content>
        {slide.payload.list.map((item, index) => (
          <>
            <Item key={item}>
              <Num data-pptx-object={PptxObjectType.Text}>
                {(index + 1).toString().padStart(2, '0')}
              </Num>
              <Name data-pptx-object={PptxObjectType.Text}>{item}</Name>
            </Item>
            <Line data-pptx-object={PptxObjectType.Shape} />
          </>
        ))}
      </Content>
    </Wrapper>
  )
}

const Line = styled.div`
  background: ${({ theme }): string => theme.colors.border.border};
  height: 1px;
  width: 100%;
`
const Num = styled.div`
  color: ${({ theme }): string => theme.colors.brand.primary};
  font-family: Roboto;
  font-size: 32px;
  font-weight: 900;
  line-height: 45px;
  width: 40px;
`
const Name = styled.div`
  color: ${({ theme }): string => theme.colors.text.primary};
  font-size: 30px;
  line-height: 42px;
`
const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 28px;
  padding: 20px 12px;
`
const Content = styled.div`
  position: absolute;
  top: 244px;
  left: 580px;
  right: 0;
`

const Title = styled.div`
  position: absolute;
  top: 93px;
  left: 117px;
  color: ${({ theme }): string => theme.colors.text.primary};
  font-size: 58px;
  font-weight: 700;
  line-height: 70px;
`

const Wrapper = styled.div`
  font-family: Arial;
  width: ${designLayoutSize.w}px;
  height: ${designLayoutSize.h}px;
  position: relative;
  /* border: solid 1px ${({ theme }): string => theme.colors.text.primary}; */
  color: ${({ theme }): string => theme.colors.text.primary};
  background-color: ${({ theme }): string => theme.colors.border.divider};

  &,
  * {
    box-sizing: border-box;
  }
`

export default SlideComponent
